/**
 * The Files database: its rows come from canvas files, so automations update
 * its user columns only and never create rows or write system columns.
 */
import {
  FILE_INDEX_COLUMN_IDS,
  FILE_INDEX_DATABASE_ID_PREFIX,
  FILE_INDEX_MANAGED_BY,
} from '@streamlain/database-identity';

import type { ColumnInfo } from '../../services/database-discovery';

const isManagedColumn = (data: Record<string, unknown> | undefined) =>
  data?.managedBy === FILE_INDEX_MANAGED_BY || data?.systemManaged === true;

export function isFileIndexTable(
  tableId: string | undefined,
  columns: readonly ColumnInfo[]
): boolean {
  return (
    (typeof tableId === 'string' &&
      tableId.startsWith(`${FILE_INDEX_DATABASE_ID_PREFIX}-`)) ||
    columns.some(column => isManagedColumn(column.data))
  );
}

/** A system column of the Files database (read-only for automations). */
export function isFileIndexSystemColumn(column: ColumnInfo): boolean {
  return (
    column.id === 'title' ||
    FILE_INDEX_COLUMN_IDS.includes(
      column.id as (typeof FILE_INDEX_COLUMN_IDS)[number]
    ) ||
    isManagedColumn(column.data)
  );
}
